export { default } from './platform/mobile'
